

import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getBirthPlaces = async (searchString) => {
  const data = await request.get(
    `/RentPlace/address/city`,
    {
      searchString,
    },
    'При загрузке адресов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useBirthPlaces = (search) =>
  useQuery([queries.addresses, search], () => getBirthPlaces(search), {
    placeholderData: [],
  });

export default useBirthPlaces;
